import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
const ProtectedRoute = ({ allowPartial = false }) => {
  const { user, token, loading } = useAuth();
    const navigate = useNavigate();

  useEffect(() => {
    if (!loading && !token) {
      navigate("/landing");
    }
  }, [loading, token]);


  if (loading) return <div className="preloader"></div>;



  
  if (token == null) {
    return <Navigate to="/landing" />;
  }

  if (!allowPartial) {
    if (user?.profile_status !== "complete") return <Navigate to="/profile-information" />;
    if (user?.status !== "approved") return <Navigate to="/contact-admin" />;
  }

  // pass user down through context
  return <Outlet context={{ user, token, loading }} />;
};

export default ProtectedRoute;
